module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/lr-74dcec3fec3f73e24a0a362de1a2e496.svg";